<div class="fcp-checkbox" [ngClass]="{ 'fcp-checkbox-given': isUsingGivenValue }">
    <label #label>
        <div class="fcp-checkbox-container" [ngClass]="{ disabled: disabled }">
            <input
                type="checkbox"
                [attr.data-e2e-hook]="e2eHook"
                [id]="inputId"
                [disabled]="disabled"
                [required]="required"
                [checked]="checked"
                [indeterminate]="indeterminate"
                (click)="onClick()"
                (change)="onChange($event)"
                #input
            />
            <fcp-icon class="fcp-checkbox-checkmark" *ngIf="checked" [icon]="['far', 'check']"></fcp-icon>
            <fcp-icon
                class="fcp-checkbox-checkmark"
                *ngIf="indeterminate && !checked"
                [icon]="['far', 'minus']"
            ></fcp-icon>
        </div>

        <div>
            <div class="fcp-checkbox-label">
                <ng-content></ng-content>
            </div>

            <div class="fcp-checkbox-caption">
                <ng-content select="[fcpCaption]"></ng-content>
            </div>
        </div>
    </label>
</div>
